import {Pagination} from '../pagination.model';
import {Contract} from '../../../../contracts/shared/model/contract.model';

export class ContractPage extends Pagination {
  content: Contract[] = [];
}
